var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "headersearch" }, [
    _c("div", { staticClass: "h4 headersearch__title underline" }, [
      _vm._v("Wat zoek je?"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "column small-24 medium-10" }, [
        _c("div", { staticClass: "tabs" }, [
          _c(
            "div",
            {
              staticClass: "tabs__tab",
              class: { "tabs__tab--active": _vm.currentType == "doen" },
              on: {
                click: function ($event) {
                  return _vm.setTab("doen")
                },
              },
            },
            [_vm._v("\n                    Ik wil iets doen\n                ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tabs__tab",
              class: { "tabs__tab--active": _vm.currentType == "leren" },
              on: {
                click: function ($event) {
                  return _vm.setTab("leren")
                },
              },
            },
            [
              _vm._v(
                "\n                    Ik wil iets leren\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tabs__tab",
              class: { "tabs__tab--active": _vm.currentType == "groep" },
              on: {
                click: function ($event) {
                  return _vm.setTab("groep")
                },
              },
            },
            [
              _vm._v(
                "\n                    Ik zoek een groep of initiatief\n                "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "column small-24 medium-14" }, [
        _c(
          "div",
          { staticClass: "headersearch__content" },
          [
            _vm.currentType == "doen" ? _c("ContentDoen") : _vm._e(),
            _vm._v(" "),
            _vm.currentType == "leren" ? _c("ContentLeren") : _vm._e(),
            _vm._v(" "),
            _vm.currentType == "groep" ? _c("ContentGroep") : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }